<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">
        <div class="container-fluid">
          <div class="row after-sales-wrapper">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <p class="sales-title">售后服务</p>
              <div class="sales-content">
                <p class="sales-content-item">
                  1、软件维护约定，从乙方为甲方开发的软件上线之日起12个月内，乙方为甲方提供免费维护服务。服务范围为：电话技术咨询及报障、日常
                </p>
                <p class="sales-content-item">
                  2、根据甲方系统故障的紧急程度，乙方将故障和优先级定义为紧急、严重、一般和轻微4个等级，从而提供不同的响应速度（以甲方报告故障时间为基准）
                </p>
                <p class="sales-content-item">
                  3、具体定义如下
                  <img class="table-img" src="../assets/table.png" alt="" />
                </p>
                <p class="sales-content-item">
                  4、如系统故障是紧急或严重级别故障，乙方承诺在收到故障申报后，15分钟内响应， 1小时内有实质性答复，8小时内到达现场，12小时内修复。
                </p>
                <p class="sales-content-item">5、对于涉及应用系统和数据库系统的系统故障或问题，乙方技术人员将协助甲方一起解决，提交解决方案建议供甲方参考。</p>
                <p class="sales-content-item">
                  6、在系统运行过程中，乙方应及时将系统内已知存在的缺陷和升级要求等信息通知甲方，由甲方决定是否升级。在维护期内或甲方已购买当年维护服务期内，甲方所购买的软件产品版本的小版本升级服务是免费的。乙方应对由于软件产品和应用系统设计原因所造成的任何缺陷或故障负责，乙方承诺承担由于乙方产品错误或缺陷所引起的支持服务费用，以及改正该错误或缺陷时所产生的全部费用。（乙方产品错误或缺陷所引起的系统故障不受保修期影响）
                </p>
                <p class="sales-content-item">7、免费维护期过后，系统维护仍可由乙方以优惠价格提供有偿服务，双方将另行签定合同确认</p>
                <p class="sales-content-item">8、维护工作只对本合同内约定的应用系统有效，当甲方提出新的业务需求和修改软件以适应新需要时应另行签定合同。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <contact-item />
  </div>
</template>
<script>
import contactItem from "../components/contact/contactItem.vue";
export default {
  components: { contactItem },
  name: "AfterSales",
};
</script>
<style scoped>
.after-sales-wrapper {
  padding: 20px 62px 0 62px;
}
.sales-title {
  font-size: 27px;
  font-weight: 500;
  color: #555555;
  padding-left: 13px;
  position: relative;
}
.sales-title::before {
  content: "";
  width: 1px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #386ede;
  border: 1px solid #386ede;
}
.sales-content {
  padding: 26px 14px 36px 14px;
}
.table-img {
  width: 100%;
}
.sales-content-item {
  font-size: 16px;
  font-weight: 500;
  color: #555555;
  line-height: 30px;
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/afterSales.vue